import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { GlobalVariable } from 'src/app/global';

@Injectable({
  providedIn: 'root'
})
export class RolesPartidosService {

  constructor(private http: HttpClient) { }

  public obtenerEscenarios(id_empresa){
    return this.http.get(GlobalVariable.API_SERVER_URL+"escenarios/empresa/"+id_empresa,GlobalVariable.httpOptions);
  }

  public obtenerArbitros(id_empresa){
    return this.http.get(GlobalVariable.API_SERVER_URL+"arbitros/empresa/"+id_empresa,GlobalVariable.httpOptions);
  }

  public obtenerListaRolesPartidos(paginator){
    return this.http.get(GlobalVariable.API_SERVER_URL+"rol-partido/empresa/"+paginator.filter.id_empresa+"/campeonato/"+paginator.filter.campeonato.id+"/arbitro-mesa/"+((paginator.filter.usuario.persona && paginator.filter.usuario.persona.arbitro)?paginator.filter.usuario.persona.arbitro.id:0)+"/pagina/"+paginator.currentPage+"/items-pagina/"+paginator.itemsPerPage+"/busqueda/"+paginator.search+"/columna/"+paginator.column+"/direccion/"+paginator.direction,GlobalVariable.httpOptions);
  }

  public obtenerListaTarjetas(){
    return this.http.get(GlobalVariable.API_SERVER_URL+"lista-amarillas-rojas",GlobalVariable.httpOptions);
  }

  public obtenerRolPartido(id_rol_partido){
    return this.http.get(GlobalVariable.API_SERVER_URL+"rol-partido/"+id_rol_partido,GlobalVariable.httpOptions);
  }

  public guardarRolPartido(rol_partido){
    return this.http.post(GlobalVariable.API_SERVER_URL+"rol-partido",rol_partido,GlobalVariable.httpOptions);
  }

  public actualizarRolPartido(rol_partido){
    return this.http.put(GlobalVariable.API_SERVER_URL+"rol-partido/"+rol_partido.id,rol_partido,GlobalVariable.httpOptions);
  }

  public actualizarCierreCajaRolPartido(rol_partido){
    return this.http.put(GlobalVariable.API_SERVER_URL+"rol-partido-cierre/"+rol_partido.id,rol_partido,GlobalVariable.httpOptions);
  }

  public eliminarRolPartido(rol_partido){
    return this.http.delete(GlobalVariable.API_SERVER_URL+"rol-partido/"+rol_partido.id,GlobalVariable.httpOptions);
  }

  public actualizarResultadoPartido(partido){
    return this.http.put(GlobalVariable.API_SERVER_URL+"partido/"+partido.id,partido,GlobalVariable.httpOptions);
  }

  public obtenerDetallesVentaPendientes(id_cliente){
    return this.http.get(GlobalVariable.API_SERVER_URL+"equipo/cliente/"+id_cliente+"/ventas-pendientes",GlobalVariable.httpOptions);
  }

  public obtenerHistorialPagos(id_cliente){
    return this.http.get(GlobalVariable.API_SERVER_URL+"equipo/cliente/"+id_cliente+"/historial-pagos",GlobalVariable.httpOptions);
  }

  public obtenerTablaPosiciones(datos){
    return this.http.get(GlobalVariable.API_SERVER_URL+"tabla-posiciones/campeonato/"+datos.campeonato.id+"/disciplina/"+datos.disciplina.id+"/"+datos.disciplina.nombre+"/categoria/"+datos.categoria.id+"/fase/"+datos.fase.id,GlobalVariable.httpOptions);
  }

  public obtenerTablaGoleadores(datos){
    return this.http.get(GlobalVariable.API_SERVER_URL+"tabla-goleadores/campeonato/"+datos.campeonato.id+"/disciplina/"+datos.disciplina.id+"/categoria/"+datos.categoria.id,GlobalVariable.httpOptions);
  }

  public validarDuplicidadPartido(datos){
    return this.http.post(GlobalVariable.API_SERVER_URL+"validar-partido",datos,GlobalVariable.httpOptions);
  }

  public obtenerPartidosArbitro(rol_partido_arbitro){
    let fecha_inicial=new Date(rol_partido_arbitro.fecha_inicio.year,rol_partido_arbitro.fecha_inicio.month-1,rol_partido_arbitro.fecha_inicio.day,0,0);
    let fecha_fin=new Date(rol_partido_arbitro.fecha_fin.year,rol_partido_arbitro.fecha_fin.month-1,rol_partido_arbitro.fecha_fin.day,0,0);
    return this.http.get(GlobalVariable.API_SERVER_URL+"partidos-arbitro/campeonato/"+rol_partido_arbitro.campeonato.id+"/arbitro/"+rol_partido_arbitro.arbitro.id+"/fecha-inicio/"+fecha_inicial+"/fecha-fin/"+fecha_fin,GlobalVariable.httpOptions);
  }

  public convertirPdfImg(datos){
    return this.http.post(GlobalVariable.API_SERVER_URL+"convertir-pdf-png",datos,GlobalVariable.httpOptions);
  }

  public obtenerPartido(id_partido){
    return this.http.get(GlobalVariable.API_SERVER_URL+"partidos/"+id_partido,GlobalVariable.httpOptions);
  }

  public obtenerPartidosSemana(id_empresa){
    return this.http.get(GlobalVariable.API_SERVER_URL+"partidos-semana/empresa/"+id_empresa,GlobalVariable.httpOptions);
  }

  public obtenerPartidosCruces(id_campeonato,id_categoria,id_disciplina,id_fase){
    return this.http.get(GlobalVariable.API_SERVER_URL+"partidos-cruces/campeonato/"+id_campeonato+"/categoria/"+id_categoria+"/disciplina/"+id_disciplina+"/fase/"+id_fase,GlobalVariable.httpOptions);
  }

  public obtenerRolPartidoCierres(id_rol_partido){
    return this.http.get(GlobalVariable.API_SERVER_URL+"rol-partido-cierres/"+id_rol_partido,GlobalVariable.httpOptions);
  }

  public procesarImagenPlanilla(datos){
    return this.http.post(GlobalVariable.API_SERVER_URL+"lectura-ocr-planilla-partido",datos,GlobalVariable.httpOptions);
  }
}
